import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Search } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { PROPERTY_TYPES } from '../data/mock';
import api from '../lib/api';

export default function SearchBar({ compact = false }) {
  const navigate = useNavigate();
  const [txn, setTxn] = useState('for-sale');
  const [type, setType] = useState('any');
  const [loc, setLoc] = useState('any');
  const [q, setQ] = useState('');
  const [locations, setLocations] = useState([]);

  useEffect(() => { api.get('/locations').then(r => setLocations(r.data || [])); }, []);

  const submit = (e) => {
    e && e.preventDefault();
    const params = new URLSearchParams();
    if (loc !== 'any') params.set('location', loc);
    if (q) params.set('q', q);
    const path = '/properties/' + txn + (type !== 'any' ? '/' + type : '');
    navigate(path + (params.toString() ? '?' + params.toString() : ''));
  };

  return (
    <form onSubmit={submit} className={'bg-white rounded-xl shadow-2xl border border-neutral-200 ' + (compact ? 'p-3' : 'p-4 md:p-5')}>
      <div className="flex gap-2 mb-3 border-b border-neutral-100">
        {['for-sale', 'for-rent'].map((t) => (
          <button key={t} type="button" onClick={() => setTxn(t)} className={'px-4 py-2 text-sm font-semibold border-b-2 -mb-px ' + (txn === t ? 'border-[#DC2626] text-[#DC2626]' : 'border-transparent text-neutral-600 hover:text-neutral-900')}>
            {t === 'for-sale' ? 'Buy' : 'Rent'}
          </button>
        ))}
      </div>
      <div className="grid grid-cols-1 md:grid-cols-12 gap-2">
        <div className="md:col-span-4">
          <Input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search by keyword, city, or development..." className="h-11" />
        </div>
        <div className="md:col-span-3">
          <Select value={loc} onValueChange={setLoc}>
            <SelectTrigger className="h-11"><SelectValue placeholder="Location" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="any">All Locations</SelectItem>
              {locations.map((l) => <SelectItem key={l.id} value={l.name}>{l.name}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="md:col-span-3">
          <Select value={type} onValueChange={setType}>
            <SelectTrigger className="h-11"><SelectValue placeholder="Property Type" /></SelectTrigger>
            <SelectContent>
              <SelectItem value="any">Any Type</SelectItem>
              {PROPERTY_TYPES.map((t) => <SelectItem key={t} value={t.toLowerCase()}>{t}</SelectItem>)}
            </SelectContent>
          </Select>
        </div>
        <div className="md:col-span-2">
          <Button type="submit" className="btn-primary w-full h-11 gap-2"><Search className="w-4 h-4" /> Search</Button>
        </div>
      </div>
    </form>
  );
}
